import React, { useEffect, useState } from 'react';

import logo from './assets/usku_logo.png';
import './form.css';
import { db } from './Firebase/firebase';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import PlacesAutocomplete from 'react-places-autocomplete';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    title: {
      flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
    },
}));

function Calculator(props) {

    const [id, setId] = useState("");
    const [pickup, setPickup] = useState("");
    const [dropOff, setDropOff] = useState("");
    const [deliveryFee, setDeliveryFee] = useState("");
    const [phone, setPhone] = useState("");

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const classes = useStyles();
    
    useEffect(() => {
        const businessCode = parseParams(props.location.search).code;

        if (businessCode) {
            db.collection('business_code').doc(businessCode)
                .get()
                .then((doc) => {
                    if (doc.exists) {
                        const temp = doc.data();
                        console.log(temp);
                        const email = temp.email;
    
                        db.collection("business").doc(email)
                            .get()
                            .then((doc) => {
                                const data = doc.data();
                                const address = data.no + ", " + data.street + ", " + data.city + ", " + data.postcode;
                                setPickup(address);
                            })
                    }

                })
        }

    }, [])

    function submitPrice(e) {
        e.persist();
        e.preventDefault();
        setError(null);
        setSuccess(null);

        if (id === "" || pickup === "" || dropOff === "") {
            setError("Fields cannot be empty");
            return
        }

        if (deliveryFee === "") {
            setError("Please calculate the delivery before submitting");
            return
        }

        try {
            db.collection("calculator").doc(id)
            .set({
                pickupAddress: pickup,
                dropOffAddress: dropOff,
                deliveryFee: deliveryFee,
                phone: phone,
            }).then(() => {
                setSuccess("Form submitted");
            })
        } catch (e) {
            console.log(e.message);
            setError("There is an error. Please try again");
        }
    }

    function calculateDeliveryFee(e) {
        e.persist();
        setDeliveryFee("Calculating...");
        setError(null);
        setSuccess(null);
        if (pickup === "" || dropOff === "") {
            setError("missing field");
            return;
        } else {
            const torigin = pickup.replace('&', '');
            const tdestination = dropOff.replace('&', '');

            const url = `https://usku-delivery-server.herokuapp.com/get_distance?origin=${torigin}&destination=${tdestination}`;
            fetch(url, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'}}
            )
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    setDeliveryFee(" Unable to calculate the distance.");
                    throw new Error();
                }
            })
            .then(data => {
                const distance = data.distance / 1000; // in km
                if (distance <= 10) {
                    setDeliveryFee(7);
                } else if (distance > 10 && distance <= 17) {
                    setDeliveryFee(14);
                } else if (distance > 17 && distance <= 30) {
                    setDeliveryFee(25);
                } else if (distance > 30) {
                    setDeliveryFee("");
                    setError("Delivery distance must be less than 30km");
                }
            })
            .catch(err => console.log("Error in calculating the distance. Please make sure both location are geographically correct"));
        }
    }

    const parseParams = (params = "") => {
        const rawParams = params.replace("?", "").split("&");
        const extractedParams = {};
        rawParams.forEach((item) => {
          item = item.split("=");
          extractedParams[item[0]] = item[1];
        });
        return extractedParams;
    };

    return (
        <div>
            <form className="form">
                <div className="form-container">
                    <img className="usku-logo" src={logo} alt="Usku" />
                    <h1>Calculator</h1>
                    <br/>
                    <div className="input-container">
                        <label>Order Reference Number</label>
                        <input name="id" onChange={(e) => {setId(e.target.value)}} placeholder="Order Reference Number" type="text" value={id} />
                    </div>
                    <div className="input-container">
                        <label>Pickup Address</label>
                        <PlacesAutocomplete
                            value={pickup}
                            onChange={(e) => {setPickup(e)}}
                            onSelect={(e) => {setPickup(e)}}>
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                                <input
                                {...getInputProps({
                                    placeholder: '12 Example St, Box Hill 3128',
                                    className: 'location-search-input',
                                })}
                                />
                                <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                    const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                    ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                    : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                    return (
                                    <div
                                        {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                        })}
                                    >
                                        <span>{suggestion.description}</span>
                                    </div>
                                    );
                                })}
                                </div>
                            </div>
                            )}
                        </PlacesAutocomplete>
                    </div>
                    <div className="input-container">
                        <label>Drop Off Address</label>
                        <PlacesAutocomplete
                            value={dropOff}
                            onChange={(e) => {setDropOff(e)}}
                            onSelect={(e) => {setDropOff(e)}}>
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                                <input
                                {...getInputProps({
                                    placeholder: '12 Example St, Box Hill 3128',
                                    className: 'location-search-input',
                                })}
                                />
                                <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                    const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                    ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                    : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                    return (
                                    <div
                                        {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                        })}
                                    >
                                        <span>{suggestion.description}</span>
                                    </div>
                                    );
                                })}
                                </div>
                            </div>
                            )}
                        </PlacesAutocomplete>
                    </div>
                    <div className="input-container">
                        <label>Phone Number</label>
                        <input name="id" onChange={(e) => {setPhone(e.target.value)}} placeholder="Phone Number" type="text" value={phone} />
                    </div>
                    <br/>
                    <div style={{textAlign: "center"}}>
                        <Button style={{backgroundColor: "orange", color: "black"}} onClick={calculateDeliveryFee}>Calculate Delivery Fee</Button>
                    </div>
                    <h3>Delivery Fee: $ <span>{deliveryFee}</span></h3>
                    {error === null ? <p></p> : <p style={{textAlign: "center", color: "red"}}>{error}</p>}
                    {success === null ? <p></p> : <p style={{textAlign: "center", color: "green"}}>{success}</p>}
                    <br/>
                    <input type="submit" onClick={submitPrice} value="Submit" />
                </div>
                <br/>
            </form>
        </div>

    )
}

export default Calculator;